
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getDataList:`post ${process.env.VUE_APP_API_ROOT}plate/queryDemandList.htm `,
			//列表请求数据
			getUserCourse: `/apis/tts-web-api/v1/academy/getAllCourse?`,
			// getUserCourse: `get /apis/tts-web-api/v1/academy/getUserCourse`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"magicPage"
			})
		}